import "../../scss/dashboard.scss";

/**
 * @file z
 * Global utilities.
 *
 */
(function ($, Drupal) {
  "use strict";

  Drupal.behaviors.dashboard_overview = {
    attach: function (context, settings) {
      context
        .querySelectorAll(".block-data-overview-block")
        .forEach((element) => {
          let menu = element.querySelector(".overview-slider-menu");
          let slider = element.querySelector(".data-slider");

          var flkty = new Flickity(slider, {
            // freeScroll: true,
            cellAlign: "left",
            // contain: true,
            autoPlay: false,
            fade: true,
            // wrapAround: false,
            prevNextButtons: false,
            pageDots: false,
            draggable: false,
          });

          var flkty = new Flickity(menu, {
            freeScroll: true,
            cellAlign: "left",
            contain: true,
            autoPlay: false,
            wrapAround: false,
            prevNextButtons: false,
            pageDots: false,
            asNavFor: slider,
          });
        });
    },
  };
})(jQuery, Drupal, drupalSettings);
